import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { useLocation } from 'react-router-dom';
import { Amplify, API, graphqlOperation } from 'aws-amplify';
import { fetchUserAttributes } from 'aws-amplify/auth';
import awsconfig from './aws-exports';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import logo from './icons/Verkada.png';
import handshakeIcon from './icons/fi-tr-trust-alt.svg'; // Import handshake icon
import raisedHandIcon from './icons/fi-tr-limit-hand.svg'; // Import raised hand icon
import RequestCoverage from './RequestCoverage';
import ClaimCoverage from './ClaimCoverage';
import RequestSubmitted from './RequestSubmitted';
import Navbar from './Navbar';
import Home from './Home'; // Import the new Home component


// Configure Amplify with the AWS settings from aws-exports.js
Amplify.configure(awsconfig);

function App() {
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    fetchUserAttributesAsync();
  }, []);

  async function fetchUserAttributesAsync() {
    try {
      const userAttributes = await fetchUserAttributes();
      // Commenting this out bc it keeps throwing an error; uncomment if we ever use it. 
      // We will proceed with email for now anyways.
      // const firstName = userAttributes.attributes['custom:first_name'] || userAttributes.username;
      setFirstName(firstName);
    } catch (error) {
      console.error('Error fetching user attributes', error);
    }
  }

  return (
    <Router>
      <Authenticator initialState="signUp" signUpConfig={{ hiddenDefaults: ['username'], signUpFields: [
        { label: "First Name", key: "custom:first_name", required: true, displayOrder: 1, type: "string" },
        { label: "Last Name", key: "custom:last_name", required: true, displayOrder: 2, type: "string" },
        { label: "Email", key: "email", required: true, displayOrder: 3, type: "string" },
        { label: "Password", key: "password", required: true, displayOrder: 4, type: "password" },
      ] }}>
        {({ signOut, user }) => (
          <>

          <header className="header">
            <div className="logo-container">
              <img src={logo} alt="Verkada Logo" className="logo" />
            </div>

            <div className="navbar-container">
              <Navbar signOut={signOut} />
              <button onClick={signOut} className="sign-out-button">
                Sign out
              </button>
            </div>
          </header>

            <div className="content-container">
              <Routes>
                <Route path="/request-coverage" element={<RequestCoverage user={user} />} />
                <Route path="/claim-coverage" element={<ClaimCoverage user={user} />} />
                <Route path="/request-submitted" element={<RequestSubmitted />} />
                <Route path="/home" element={<Home user={user} />} />
                <Route path="/" element={
                  <div className="centered-content">
                    <h2 className="title">What would you like to do?</h2>
                    <div className="button-container">
                      <NavLink to="/request-coverage" className="button-link">
                        <img src={raisedHandIcon} alt="Raised Hand Icon" className="button-icon" />
                        <div className="button-text">Request Coverage</div>
                      </NavLink>
                      <NavLink to="/claim-coverage" className="button-link">
                        <img src={handshakeIcon} alt="Handshake Icon" className="button-icon" />
                        <div className="button-text">Claim Coverage</div>
                      </NavLink>
                    </div>
                  </div>
                } />
              </Routes>
            </div>
          </>
        )}
      </Authenticator>
    </Router>
  );
}

export default App;